import { render, staticRenderFns } from "./VulnerabilityListItem.vue?vue&type=template&id=4138e5e4"
import script from "./VulnerabilityListItem.vue?vue&type=script&lang=ts"
export * from "./VulnerabilityListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SeverityIndicator: require('/build/apps/legacy/components/Dependencies/Common/SeverityIndicator.vue').default,ZIcon: require('/build/apps/legacy/components/zeal/ZIcon/ZIcon.vue').default,DynamicRiskPill: require('/build/apps/legacy/components/Dependencies/Common/DynamicRiskPill.vue').default,ReachabilityPill: require('/build/apps/legacy/components/Dependencies/Common/ReachabilityPill.vue').default,DButton: require('/build/apps/legacy/components/Dependencies/Base/DButton.vue').default})
